var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.07031,
    width: 43,
    height: 43,
    rx: 21.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.07031,
    width: 43,
    height: 43,
    rx: 21.5,
    stroke: "#2B43DA",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9999 25.0864C24.4886 25.0864 25.6974 23.8777 25.6974 22.389V17.2677C25.6974 15.7791 24.4886 14.5703 22.9999 14.5703C21.5113 14.5703 20.3025 15.7791 20.3025 17.2677V22.389C20.3025 23.8777 21.5113 25.0864 22.9999 25.0864ZM26.6707 20.595V22.3954C26.6707 23.4133 26.2636 24.323 25.5956 24.991C24.9276 25.659 24.0178 26.0661 22.9999 26.0661C21.982 26.0661 21.0723 25.659 20.4043 24.991C19.7427 24.323 19.3292 23.4133 19.3292 22.3954V20.595H17.9868V22.3954C17.9868 24.9401 19.8763 27.0395 22.3319 27.364V29.228H20.1308V30.5703H25.8755V29.228H23.6743V27.364C26.1236 27.0331 28.0131 24.9401 28.0131 22.3954V20.595H26.6707Z",
    fill: "#2B43DA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudio);
export default __webpack_public_path__ + "static/media/audio.10d68b8ab34c410716f056824cafd8e5.svg";
export { ForwardRef as ReactComponent };